// This file is auto-generated by @hey-api/openapi-ts

/**
 * Address
 */
export type Address = {
    id: number;
    line_one: string;
    line_two: string | null;
    city: string;
    post_code: string;
    country: string;
};

/**
 * App.Http.Requests.CoatType.StoreRequest
 */
export type AppHttpRequestsCoatTypeStoreRequest = {
    name: string;
};

/**
 * App.Http.Requests.CoatType.UpdateRequest
 */
export type AppHttpRequestsCoatTypeUpdateRequest = {
    name?: string;
};

/**
 * App.Http.Requests.ContactSubmission.StoreRequest
 */
export type AppHttpRequestsContactSubmissionStoreRequest = {
    name: string;
    email: string;
    phone?: string | null;
    subject?: string | null;
    message: string;
};

/**
 * App.Http.Requests.Invitation.StoreRequest
 */
export type AppHttpRequestsInvitationStoreRequest = {
    first_name: string;
    last_name: string;
    email: string;
    role: Role;
};

/**
 * App.Http.Requests.Location.StoreRequest
 */
export type AppHttpRequestsLocationStoreRequest = {
    name: string;
    /**
     * Address
     */
    address: {
        line_one: string;
        line_two?: string | null;
        city: string;
        post_code: string;
        country: string;
    };
    /**
     * Business Hours
     */
    business_hours: Array<{
        day_of_week: number;
        open: string;
        close: string;
    }>;
};

/**
 * App.Http.Requests.Location.UpdateRequest
 */
export type AppHttpRequestsLocationUpdateRequest = {
    name?: string;
    /**
     * Address
     */
    address?: {
        line_one?: string;
        line_two?: string | null;
        city?: string;
        post_code?: string;
        country?: string;
    };
    /**
     * Business Hours
     */
    business_hours?: Array<{
        id?: number;
        day_of_week?: number;
        open?: string;
        close?: string;
    }>;
};

/**
 * App.Http.Requests.Newsletter.StoreRequest
 */
export type AppHttpRequestsNewsletterStoreRequest = {
    email: string;
};

/**
 * App.Http.Requests.Pet.StoreRequest
 */
export type AppHttpRequestsPetStoreRequest = {
    /**
     * Details
     */
    media_id?: string;
    name: string;
    parent_id: number;
    breed: DogBreed;
    birth_date?: string | null;
    gender: Gender;
    size_category_id: number;
    coat_type_id: number;
    /**
     * Medical Information
     */
    microchip_number?: string | null;
    weight?: number | null;
    vet_name?: string | null;
    vet_phone?: string | null;
    vaccinated?: boolean | null;
    allergies?: string | null;
    medical_notes?: string | null;
    /**
     * Notes
     */
    grooming_preferences?: string | null;
    internal_notes?: string | null;
};

/**
 * App.Http.Requests.Pet.UpdateRequest
 */
export type AppHttpRequestsPetUpdateRequest = {
    /**
     * Details
     */
    media_id?: string | null;
    name?: string | null;
    parent_id?: number | null;
    breed?: DogBreed;
    birth_date?: string | null;
    gender?: Gender;
    size_category_id?: number;
    coat_type_id?: number;
    /**
     * Medical Information
     */
    microchip_number?: string | null;
    weight?: number | null;
    vet_name?: string | null;
    vet_phone?: string | null;
    vaccinated?: boolean | null;
    allergies?: string | null;
    medical_notes?: string | null;
    /**
     * Notes
     */
    grooming_preferences?: string | null;
    internal_notes?: string | null;
};

/**
 * App.Http.Requests.Schedule.UpdateRequest
 */
export type AppHttpRequestsScheduleUpdateRequest = {
    days: Array<{
        id?: number;
        day?: DayOfWeek;
        active_from: string;
        times?: Array<{
            from: string;
            to: string;
        }>;
    }>;
};

/**
 * App.Http.Requests.Service.StoreRequest
 */
export type AppHttpRequestsServiceStoreRequest = {
    name: string;
    description?: string | null;
    colour: string;
    currency: Currency;
    notes?: string | null;
    variants: Array<{
        breed?: DogBreed;
        size_category_id?: number | null;
        coat_type_id?: number | null;
        is_default: boolean;
        duration: number;
        price_in_cents: number;
    }>;
};

/**
 * App.Http.Requests.Service.UpdateRequest
 */
export type AppHttpRequestsServiceUpdateRequest = {
    name?: string;
    description?: string | null;
    colour?: string;
    currency?: Currency;
    notes?: string | null;
};

/**
 * App.Http.Requests.SizeCategory.StoreRequest
 */
export type AppHttpRequestsSizeCategoryStoreRequest = {
    name: string;
    from_weight_lbs: number;
    to_weight_lbs: number;
};

/**
 * App.Http.Requests.SizeCategory.UpdateRequest
 */
export type AppHttpRequestsSizeCategoryUpdateRequest = {
    name?: string;
    from_weight_lbs: number;
    to_weight_lbs: number;
};

/**
 * App.Http.Requests.SupportTicket.StoreRequest
 */
export type AppHttpRequestsSupportTicketStoreRequest = {
    message: string;
    page_url?: string | null;
};

/**
 * App.Http.Requests.Tenant.UpdateRequest
 */
export type AppHttpRequestsTenantUpdateRequest = {
    business_name?: string;
    contact_email?: string | null;
    contact_phone?: string | null;
    is_booking_enabled?: boolean;
};

/**
 * App.Http.Requests.TenantOnboarding.RegisterRequest
 */
export type AppHttpRequestsTenantOnboardingRegisterRequest = {
    email: string;
    first_name: string;
    last_name: string;
    password: string;
    plan?: string | null;
    billing_period?: string | null;
    password_confirmation: string;
};

/**
 * App.Http.Requests.TenantOnboarding.UpdateRequest
 */
export type AppHttpRequestsTenantOnboardingUpdateRequest = {
    business_name: string;
    business_type: TenantType;
    stage: TenantOnboardingStage;
};

/**
 * App.Http.Requests.User.UpdateRequest
 */
export type AppHttpRequestsUserUpdateRequest = {
    first_name?: string;
    last_name?: string;
    role?: 'Admin' | 'Groomer' | 'Receptionist';
};

/**
 * Appointment
 */
export type Appointment = {
    id: number;
    status: AppointmentStatus;
    approved_at: string;
    groomer: User;
    client: Client;
    pet: Pet;
    services: Array<AppointmentService>;
    price_in_cents: number;
    currency: Currency;
    notes: string | null;
    pet_breed_at_creation: DogBreed;
    /**
     * TODO: need to make this have histiry as well so appoiments have a snapshot
     * 'pet_size_at_creation' => $this->pet_size_at_creation,
     * 'pet_coat_at_creation' => $this->pet_coat_at_creation,
     */
    start_at: string;
    finish_at: string;
    /**
     * Meta
     */
    created_at: string;
    updated_at: string;
};

/**
 * AppointmentMetadata
 */
export type AppointmentMetadata = {
    duration: string;
    price_in_cents: string;
    currency: string;
};

/**
 * AppointmentService
 */
export type AppointmentService = {
    id: number;
    service: Service;
    service_values: ServiceValues;
};

/**
 * AppointmentSlot
 */
export type AppointmentSlot = {
    start_at: string;
    finish_at: string;
    groomer: {
        id: string;
        first_name: string;
        last_name: string;
    };
};

/**
 * AppointmentStatus
 */
export enum AppointmentStatus {
    PENDING = 'Pending',
    CONFIRMED = 'Confirmed',
    COMPLETED = 'Completed',
    NO_SHOW = 'No Show',
    CANCELLED = 'Cancelled'
}

/**
 * BreedType
 */
export enum BreedType {
    ALL = 'All',
    'SMALL &_SHORT_HAIRED' = 'Small & Short Haired',
    'SMALL &_LONG_HAIRED' = 'Small & Long Haired',
    'MEDIUM &_SHORT_HAIRED' = 'Medium & Short Haired',
    'MEDIUM &_LONG_HAIRED' = 'Medium & Long Haired',
    'LARGE &_SHORT_HAIRED' = 'Large & Short Haired',
    'LARGE &_LONG_HAIRED' = 'Large & Long Haired',
    DOODLES = 'Doodles',
    FLAT_FACED = 'Flat-Faced',
    HEAVY_SHEDDERS = 'Heavy Shedders'
}

/**
 * BusinessHour
 */
export type BusinessHour = {
    id: number;
    day_of_week: number;
    open: string;
    close: string;
};

/**
 * CalendarBlock
 */
export type CalendarBlock = {
    id: number;
    type: CalendarBlockType;
    start_at: string;
    finish_at: string;
};

/**
 * CalendarBlockType
 */
export enum CalendarBlockType {
    UNAVAILABLE = 'unavailable'
}

/**
 * Client
 */
export type Client = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    image: string;
    pets: Array<Pet>;
    internal_notes: string | null;
    /**
     * Meta
     */
    created_at: string | null;
    updated_at: string | null;
    deleted_at: string | null;
    approved_at: string | null;
};

/**
 * CoatType
 */
export type CoatType = {
    id: number;
    created_at: string | null;
    updated_at: string | null;
    values?: {
        id: string;
        name: string;
        created_at: string;
        updated_at: string;
    };
};

/**
 * Colour
 */
export enum Colour {
    '#94A3B8' = '#94a3b8',
    '#EA580C' = '#ea580c',
    '#DC2626' = '#dc2626',
    '#16A34A' = '#16a34a',
    '#1E3A8A' = '#1e3a8a',
    '#9333EA' = '#9333ea',
    '#14B8A6' = '#14b8a6',
    '#F59E0B' = '#f59e0b',
    '#3B82F6' = '#3b82f6',
    '#10B981' = '#10b981',
    '#F43F5E' = '#f43f5e'
}

/**
 * CreateRequest
 */
export type CreateRequest = {
    price_in_cents: number;
    notes?: string | null;
    start_at: string;
    finish_at: string;
    groomer_id: number;
    client_id?: number | null;
    pet_id?: number | null;
    services: Array<number>;
    /**
     * New client fields
     */
    new_client?: {
        first_name?: string;
        last_name?: string;
        email?: string;
        phone?: string;
    };
    /**
     * New pet fields
     */
    new_pet?: {
        name?: string;
        breed?: DogBreed;
        size_category_id?: number;
        coat_type_id?: number;
    };
};

/**
 * Currency
 */
export enum Currency {
    USD = 'USD',
    EUR = 'EUR',
    GBP = 'GBP',
    CAD = 'CAD',
    AUD = 'AUD'
}

/**
 * DayOfWeek
 */
export enum DayOfWeek {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
    _4 = 4,
    _5 = 5,
    _6 = 6
}

/**
 * DogBreed
 */
export enum DogBreed {
    AFFENPINSCHER = 'Affenpinscher',
    AFGHAN_HOUND = 'Afghan Hound',
    AFRICANIS = 'Africanis',
    AIREDALE_TERRIER = 'Airedale Terrier',
    AKITA = 'Akita',
    ALASKAN_MALAMUTE = 'Alaskan Malamute',
    AMERICAN_BULLDOG = 'American Bulldog',
    AMERICAN_COCKER_SPANIEL = 'American Cocker Spaniel',
    AMERICAN_ENGLISH_COONHOUND = 'American English Coonhound',
    AMERICAN_ESKIMO_DOG = 'American Eskimo Dog',
    AMERICAN_FOXHOUND = 'American Foxhound',
    AMERICAN_HAIRLESS_TERRIER = 'American Hairless Terrier',
    AMERICAN_LEOPARD_HOUND = 'American Leopard Hound',
    AMERICAN_STAFFORDSHIRE_TERRIER = 'American Staffordshire Terrier',
    AMERICAN_WATER_SPANIEL = 'American Water Spaniel',
    ANATOLIAN_SHEPHERD = 'Anatolian Shepherd',
    APPENZELLER_SENNENHUND = 'Appenzeller Sennenhund',
    AUSTRALIAN_CATTLE_DOG = 'Australian Cattle Dog',
    AUSTRALIAN_KELPIE = 'Australian Kelpie',
    AUSTRALIAN_SHEPHERD = 'Australian Shepherd',
    AUSTRALIAN_SILKY_TERRIER = 'Australian Silky Terrier',
    AUSTRALIAN_TERRIER = 'Australian Terrier',
    AZAWAKH = 'Azawakh',
    BARBET = 'Barbet',
    BASENJI = 'Basenji',
    BASSET_BLEU_DE_GASCOGNE = 'Basset Bleu de Gascogne',
    BASSET_FAUVE_DE_BRETAGNE = 'Basset Fauve de Bretagne',
    BASSET_HOUND = 'Basset Hound',
    BAVARIAN_MOUNTAIN_HOUND = 'Bavarian Mountain Hound',
    BEAGLE = 'Beagle',
    BEARDED_COLLIE = 'Bearded Collie',
    BEAUCERON = 'Beauceron',
    BEDLINGTON_TERRIER = 'Bedlington Terrier',
    BELGIAN_LAEKENOIS = 'Belgian Laekenois',
    BELGIAN_MALINOIS = 'Belgian Malinois',
    'BELGIAN_SHEEPDOG (_GROENENDAEL)' = 'Belgian Sheepdog (Groenendael)',
    BELGIAN_TERVUREN = 'Belgian Tervuren',
    BERGAMASCO_SHEPHERD = 'Bergamasco Shepherd',
    BERGER_PICARD = 'Berger Picard',
    BERNESE_MOUNTAIN_DOG = 'Bernese Mountain Dog',
    BICHON_FRISE = 'Bichon Frise',
    BIEWER_TERRIER = 'Biewer Terrier',
    BLACK_RUSSIAN_TERRIER = 'Black Russian Terrier',
    BLACK_AND_TAN_COONHOUND = 'Black and Tan Coonhound',
    BLOODHOUND = 'Bloodhound',
    BLUETICK_COONHOUND = 'Bluetick Coonhound',
    BOERBOEL = 'Boerboel',
    BOLOGNESE = 'Bolognese',
    BORDER_COLLIE = 'Border Collie',
    BORDER_TERRIER = 'Border Terrier',
    BORZOI = 'Borzoi',
    BOSTON_TERRIER = 'Boston Terrier',
    BOUVIER_DES_FLANDRES = 'Bouvier des Flandres',
    BOXER = 'Boxer',
    BOYKIN_SPANIEL = 'Boykin Spaniel',
    BRACCO_ITALIANO = 'Bracco Italiano',
    "BRAQUE_D'_AUVERGNE" = "Braque d'Auvergne",
    BRIARD = 'Briard',
    BRITTANY = 'Brittany',
    BRUSSELS_GRIFFON = 'Brussels Griffon',
    BULL_TERRIER = 'Bull Terrier',
    'BULL_TERRIER (_MINIATURE)' = 'Bull Terrier (Miniature)',
    BULLDOG = 'Bulldog',
    BULLMASTIFF = 'Bullmastiff',
    CAIRN_TERRIER = 'Cairn Terrier',
    CANAAN_DOG = 'Canaan Dog',
    CANADIAN_ESKIMO_DOG = 'Canadian Eskimo Dog',
    CANE_CORSO = 'Cane Corso',
    CARDIGAN_WELSH_CORGI = 'Cardigan Welsh Corgi',
    CATALAN_SHEEPDOG = 'Catalan Sheepdog',
    CAVALIER_KING_CHARLES_SPANIEL = 'Cavalier King Charles Spaniel',
    CESKY_TERRIER = 'Cesky Terrier',
    CHESAPEAKE_BAY_RETRIEVER = 'Chesapeake Bay Retriever',
    CHIHUAHUA = 'Chihuahua',
    CHINESE_CRESTED = 'Chinese Crested',
    CHINOOK = 'Chinook',
    CHOW_CHOW = 'Chow Chow',
    "CIRNECO_DELL'_ETNA" = "Cirneco dell'Etna",
    CLUMBER_SPANIEL = 'Clumber Spaniel',
    'COCKER_SPANIEL (_ENGLISH)' = 'Cocker Spaniel (English)',
    COLLIE = 'Collie',
    COTON_DE_TULEAR = 'Coton de Tulear',
    CURLY_COATED_RETRIEVER = 'Curly-Coated Retriever',
    DACHSHUND = 'Dachshund',
    DALMATIAN = 'Dalmatian',
    DANDIE_DINMONT_TERRIER = 'Dandie Dinmont Terrier',
    DOBERMAN_PINSCHER = 'Doberman Pinscher',
    DOGO_ARGENTINO = 'Dogo Argentino',
    DOGUE_DE_BORDEAUX = 'Dogue de Bordeaux',
    DOODLE = 'Doodle',
    DUTCH_SHEPHERD = 'Dutch Shepherd',
    ENGLISH_FOXHOUND = 'English Foxhound',
    ENGLISH_SETTER = 'English Setter',
    ENGLISH_SHEPHERD = 'English Shepherd',
    ENGLISH_SPRINGER_SPANIEL = 'English Springer Spaniel',
    'ENGLISH_TOY_TERRIER (_BLACK &_TAN)' = 'English Toy Terrier (Black & Tan)',
    ENTLEBUCHER_MOUNTAIN_DOG = 'Entlebucher Mountain Dog',
    ESTRELA_MOUNTAIN_DOG = 'Estrela Mountain Dog',
    EURASIER = 'Eurasier',
    FIELD_SPANIEL = 'Field Spaniel',
    FINNISH_LAPPHUND = 'Finnish Lapphund',
    FINNISH_SPITZ = 'Finnish Spitz',
    FLAT_COATED_RETRIEVER = 'Flat-Coated Retriever',
    FOX_TERRIER = 'Fox Terrier',
    FRENCH_BULLDOG = 'French Bulldog',
    GERMAN_LONGHAIRED_POINTER = 'German Longhaired Pointer',
    GERMAN_PINSCHER = 'German Pinscher',
    GERMAN_SHEPHERD_DOG = 'German Shepherd Dog',
    GERMAN_SHORTHAIRED_POINTER = 'German Shorthaired Pointer',
    'GERMAN_SPANIEL (_WACHTELHUND)' = 'German Spaniel (Wachtelhund)',
    GERMAN_SPITZ = 'German Spitz',
    GERMAN_WIREHAIRED_POINTER = 'German Wirehaired Pointer',
    GIANT_SCHNAUZER = 'Giant Schnauzer',
    GLEN_OF_IMAAL_TERRIER = 'Glen of Imaal Terrier',
    GOLDEN_RETRIEVER = 'Golden Retriever',
    GORDON_SETTER = 'Gordon Setter',
    GRAND_BASSET_GRIFFON_VENDÉEN = 'Grand Basset Griffon Vendéen',
    GRAND_BLEU_DE_GASCOGNE = 'Grand Bleu de Gascogne',
    GREAT_DANE = 'Great Dane',
    GREAT_PYRENEES = 'Great Pyrenees',
    GREATER_SWISS_MOUNTAIN_DOG = 'Greater Swiss Mountain Dog',
    GREENLAND_DOG = 'Greenland Dog',
    GREYHOUND = 'Greyhound',
    GRIFFON_NIVERNAIS = 'Griffon Nivernais',
    HAMILTONSTOVARE = 'Hamiltonstovare',
    HANOVERIAN_SCENTHOUND = 'Hanoverian Scenthound',
    HARRIER = 'Harrier',
    HAVANESE = 'Havanese',
    HOVAWART = 'Hovawart',
    HUNGARIAN_WIREHAIRED_VIZSLA = 'Hungarian Wirehaired Vizsla',
    IBIZAN_HOUND = 'Ibizan Hound',
    ICELANDIC_SHEEPDOG = 'Icelandic Sheepdog',
    IRISH_RED_AND_WHITE_SETTER = 'Irish Red and White Setter',
    IRISH_SETTER = 'Irish Setter',
    IRISH_TERRIER = 'Irish Terrier',
    IRISH_WATER_SPANIEL = 'Irish Water Spaniel',
    IRISH_WOLFHOUND = 'Irish Wolfhound',
    ITALIAN_GREYHOUND = 'Italian Greyhound',
    JACK_RUSSELL_TERRIER = 'Jack Russell Terrier',
    JAPANESE_AKITA = 'Japanese Akita',
    JAPANESE_CHIN = 'Japanese Chin',
    JAPANESE_SPITZ = 'Japanese Spitz',
    KAI_KEN = 'Kai Ken',
    KARELIAN_BEAR_DOG = 'Karelian Bear Dog',
    KEESHOND = 'Keeshond',
    KERRY_BLUE_TERRIER = 'Kerry Blue Terrier',
    KING_CHARLES_SPANIEL = 'King Charles Spaniel',
    KISHNU_KEN = 'Kishnu Ken',
    KOMONDOR = 'Komondor',
    KOOIKERHONDJE = 'Kooikerhondje',
    KOREA_JINDO = 'Korea Jindo',
    KROMFOHRLANDER = 'Kromfohrlander',
    KUVASZ = 'Kuvasz',
    LABRADOR_RETRIEVER = 'Labrador Retriever',
    LAGOTTO_ROMAGNOLO = 'Lagotto Romagnolo',
    LAKELAND_TERRIER = 'Lakeland Terrier',
    LANCASHIRE_HEELER = 'Lancashire Heeler',
    LARGE_MUNSTERLANDER = 'Large Munsterlander',
    LEONBERGER = 'Leonberger',
    LHASA_APSO = 'Lhasa Apso',
    LÖWCHEN = 'Löwchen',
    MALTESE = 'Maltese',
    MANCHESTER_TERRIER = 'Manchester Terrier',
    MAREMMA_SHEEPDOG = 'Maremma Sheepdog',
    'MASTIFF (_ENGLISH)' = 'Mastiff (English)',
    MINIATURE_AMERICAN_SHEPHERD = 'Miniature American Shepherd',
    MINIATURE_PINSCHER = 'Miniature Pinscher',
    MINIATURE_SCHNAUZER = 'Miniature Schnauzer',
    MIXED_OTHER = 'Mixed/Other',
    MUDI = 'Mudi',
    NEAPOLITAN_MASTIFF = 'Neapolitan Mastiff',
    NEDERLANDSE_KOOIKERHONDJE = 'Nederlandse Kooikerhondje',
    NEWFOUNDLAND = 'Newfoundland',
    NORFOLK_TERRIER = 'Norfolk Terrier',
    NORWEGIAN_BUHUND = 'Norwegian Buhund',
    NORWEGIAN_ELKHOUND = 'Norwegian Elkhound',
    NORWEGIAN_LUNDHUND = 'Norwegian Lundhund',
    NORWICH_TERRIER = 'Norwich Terrier',
    NOVA_SCOTIA_DUCK_TOLLING_RETRIEVER = 'Nova Scotia Duck Tolling Retriever',
    OLD_ENGLISH_SHEEPDOG = 'Old English Sheepdog',
    OTTERHOUND = 'Otterhound',
    PAPILLON = 'Papillon',
    PARSON_RUSSELL_TERRIER = 'Parson Russell Terrier',
    PEKINGESE = 'Pekingese',
    PEMBROKE_WELSH_CORGI = 'Pembroke Welsh Corgi',
    PETIT_BASSET_GRIFFON_VENDÉEN = 'Petit Basset Griffon Vendéen',
    PHARAOH_HOUND = 'Pharaoh Hound',
    PICARDY_SPANIEL = 'Picardy Spaniel',
    PLOTT_HOUND = 'Plott Hound',
    'POINTER (_ENGLISH)' = 'Pointer (English)',
    POLISH_LOWLAND_SHEEPDOG = 'Polish Lowland Sheepdog',
    POMERANIAN = 'Pomeranian',
    POODLE = 'Poodle',
    PORCELAINE = 'Porcelaine',
    PORTUGUESE_PODENGO = 'Portuguese Podengo',
    PORTUGUESE_POINTER = 'Portuguese Pointer',
    PORTUGUESE_WATER_DOG = 'Portuguese Water Dog',
    PUG = 'Pug',
    PULI = 'Puli',
    PUMI = 'Pumi',
    PYRENEAN_MASTIFF = 'Pyrenean Mastiff',
    PYRENEAN_SHEPHERD = 'Pyrenean Shepherd',
    RAFEIRO_DO_ALENTEJO = 'Rafeiro do Alentejo',
    RAT_TERRIER = 'Rat Terrier',
    REDBONE_COONHOUND = 'Redbone Coonhound',
    RHODESIAN_RIDGEBACK = 'Rhodesian Ridgeback',
    ROTTWEILER = 'Rottweiler',
    RUSSIAN_TOY = 'Russian Toy',
    RUSSIAN_TSVETNAYA_BOLONKA = 'Russian Tsvetnaya Bolonka',
    SAINT_BERNARD = 'Saint Bernard',
    SALUKI = 'Saluki',
    SAMOYED = 'Samoyed',
    SCHIPPERKE = 'Schipperke',
    'SCHNAUZER (_STANDARD)' = 'Schnauzer (Standard)',
    SCOTTISH_DEERHOUND = 'Scottish Deerhound',
    SCOTTISH_TERRIER = 'Scottish Terrier',
    SEALYHAM_TERRIER = 'Sealyham Terrier',
    SEGUGIO_ITALIANO = 'Segugio Italiano',
    SHAR_PEI = 'Shar Pei',
    SHETLAND_SHEEPDOG = 'Shetland Sheepdog',
    SHIBA_INU = 'Shiba Inu',
    SHIH_TZU = 'Shih Tzu',
    SHIKOKU = 'Shikoku',
    SIBERIAN_HUSKY = 'Siberian Husky',
    SILKY_TERRIER = 'Silky Terrier',
    SKYE_TERRIER = 'Skye Terrier',
    SLOUGHI = 'Sloughi',
    SLOVAKIAN_ROUGH_HAIRED_POINTER = 'Slovakian Rough Haired Pointer',
    SMALL_MUNSTERLANDER = 'Small Munsterlander',
    SOFT_COATED_WHEATEN_TERRIER = 'Soft Coated Wheaten Terrier',
    SPANISH_WATER_DOG = 'Spanish Water Dog',
    SPINONE_ITALIANO = 'Spinone Italiano',
    STAFFORDSHIRE_BULL_TERRIER = 'Staffordshire Bull Terrier',
    SUSSEX_SPANIEL = 'Sussex Spaniel',
    SWEDISH_LAPPHUND = 'Swedish Lapphund',
    SWEDISH_VALLHUND = 'Swedish Vallhund',
    TEDDY_ROOSEVELT_TERRIER = 'Teddy Roosevelt Terrier',
    THAI_RIDGEBACK = 'Thai Ridgeback',
    TIBETAN_MASTIFF = 'Tibetan Mastiff',
    TIBETAN_SPANIEL = 'Tibetan Spaniel',
    TIBETAN_TERRIER = 'Tibetan Terrier',
    TOSA = 'Tosa',
    TOY_FOX_TERRIER = 'Toy Fox Terrier',
    TRANSYLVANIAN_HOUND = 'Transylvanian Hound',
    TREEING_TENNESSEE_BRINDLE = 'Treeing Tennessee Brindle',
    TREEING_WALKER_COONHOUND = 'Treeing Walker Coonhound',
    VIZSLA = 'Vizsla',
    WEIMARANER = 'Weimaraner',
    WELSH_SPRINGER_SPANIEL = 'Welsh Springer Spaniel',
    WELSH_TERRIER = 'Welsh Terrier',
    WEST_HIGHLAND_WHITE_TERRIER = 'West Highland White Terrier',
    WESTPHALIAN_DACHSBRACKE = 'Westphalian Dachsbracke',
    WHIPPET = 'Whippet',
    WHITE_SWISS_SHEPHERD_DOG = 'White Swiss Shepherd Dog',
    WIREHAIRED_POINTING_GRIFFON = 'Wirehaired Pointing Griffon',
    WIREHAIRED_VIZSLA = 'Wirehaired Vizsla',
    XOLOITZCUINTLI = 'Xoloitzcuintli',
    YAKUTIAN_LAIKA = 'Yakutian Laika',
    YORKSHIRE_TERRIER = 'Yorkshire Terrier'
}

/**
 * ForgotPasswordRequest
 */
export type ForgotPasswordRequest = {
    email: string;
};

/**
 * Gender
 */
export enum Gender {
    MALE = 'Male',
    FEMALE = 'Female'
}

/**
 * Invitation
 */
export type Invitation = {
    id: number;
    email: string;
    role: Role;
    data: {
        first_name: string;
        last_name: string;
        verified_at: string;
    };
    inviter: {
        id: number;
        name: string;
    };
    business_name: string;
    expires_at: string;
};

/**
 * Location
 */
export type Location = {
    id: number;
    name: string;
    address: Address;
    business_hours: Array<BusinessHour>;
};

/**
 * LoginRequest
 */
export type LoginRequest = {
    email: string;
    password: string;
};

/**
 * MediaObject
 */
export type MediaObject = {
    uuid: string;
    bucket: string;
    key: string;
    url: string;
};

/**
 * Pet
 */
export type Pet = {
    /**
     * Details
     */
    id: number;
    parent: User;
    name: string;
    breed: Array<DogBreed>;
    breed_type: BreedType;
    size_category?: SizeCategory;
    coat_type?: CoatType;
    birth_date: string | null;
    gender: string | null;
    /**
     * Medical Information
     */
    microchip_number: string | null;
    weight: number | null;
    vet_name: string | null;
    vet_phone: string | null;
    vaccinated: boolean | null;
    allergies: string | null;
    medical_notes: string | null;
    /**
     * Notes
     */
    grooming_preferences: string | null;
    internal_notes: string | null;
    tags: Array<Tag>;
    /**
     * Media
     */
    image: string;
    /**
     * Meta
     */
    created_at: string | null;
    updated_at: string | null;
    deleted_at: string | null;
    approved_at: string | null;
};

/**
 * PublicCancelRequest
 */
export type PublicCancelRequest = {
    signature: string;
    expires: number;
};

/**
 * PublicConfirmRequest
 */
export type PublicConfirmRequest = {
    signature: string;
    expires: number;
};

/**
 * PublicTenant
 */
export type PublicTenant = {
    id: string;
    name: string;
    contact_email: string;
    contact_phone: string;
    location: {
        id: string;
        name: string;
        address: {
            id: string;
            line_one: string;
            line_two: string;
            city: string;
            post_code: string;
            country: string;
        };
        business_hours: string;
    };
    booking_url: string;
};

/**
 * RegisterRequest
 */
export type RegisterRequest = {
    password: string;
    password_confirmation: string;
};

/**
 * RescheduleRequest
 */
export type RescheduleRequest = {
    start_at: string;
    finish_at: string;
    groomer_id: number;
};

/**
 * ResetPasswordRequest
 */
export type ResetPasswordRequest = {
    token: string;
    email: string;
    password: string;
    confirm_password: string;
};

/**
 * Role
 */
export enum Role {
    SUPER_ADMIN = 'Super Admin',
    ADMIN = 'Admin',
    GROOMER = 'Groomer',
    RECEPTIONIST = 'Receptionist'
}

/**
 * Schedule
 */
export type Schedule = {
    id: number;
    team_member_id: number;
    day: string;
    active_from: {
        [key: string]: unknown;
    };
    times: Array<ScheduleTime>;
};

/**
 * ScheduleTime
 */
export type ScheduleTime = {
    id: number;
    from: string;
    to: string;
};

/**
 * SendVerificationCodeRequest
 */
export type SendVerificationCodeRequest = {
    email: string;
};

/**
 * Service
 */
export type Service = {
    id: number;
    colour: Colour;
    created_at: string | null;
    updated_at: string | null;
    deleted_at: string | null;
    values?: {
        id: string;
        name: string;
        description: string;
        notes: string;
        pricing_type: string;
        is_latest: boolean;
        currency: Currency;
        variants?: Array<ServiceValueVariant>;
        created_at: string;
        updated_at: string;
    };
};

/**
 * ServiceValueVariant
 */
export type ServiceValueVariant = {
    id: number;
    size_category_id: number | null;
    coat_type_id: number | null;
    size_category?: SizeCategory;
    coat_type?: CoatType;
    breed: string;
    is_default: boolean;
    price_in_cents: number;
    duration: number;
};

/**
 * ServiceValues
 */
export type ServiceValues = {
    id: number;
    name: string;
    description: string;
    notes: string;
    is_latest: boolean;
    currency: Currency;
    variants: Array<ServiceValueVariant>;
    created_at: string;
    updated_at: string;
};

/**
 * SizeCategory
 */
export type SizeCategory = {
    id: number;
    created_at: string | null;
    updated_at: string | null;
    values?: {
        id: string;
        name: string;
        from_weight_lbs: string;
        to_weight_lbs: string;
        created_at: string;
        updated_at: string;
    };
};

/**
 * StoreRequest
 */
export type StoreRequest = {
    /**
     * Details
     */
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    internal_notes?: string | null;
    /**
     * Pets
     */
    pets?: Array<{
        name: string;
        breed?: DogBreed;
        birth_date?: string | null;
        gender?: Gender;
        size_category_id: number;
        coat_type_id: number;
        internal_notes?: string | null;
    }>;
};

/**
 * SyncRequest
 */
export type SyncRequest = {
    variants: Array<{
        is_default: boolean;
        breed?: DogBreed;
        size_category_id?: number | null;
        coat_type_id?: number | null;
        price_in_cents: number;
        duration: number;
    }>;
};

/**
 * Tag
 */
export type Tag = {
    name: string;
    colour: string;
};

/**
 * Tenant
 */
export type Tenant = {
    id: string;
    name: string;
    stage: string;
    type: string;
    onboarded_at: string;
    business_hours: Array<BusinessHour>;
    subscription_expires_at: string;
    contact_email: string;
    contact_phone: string;
    booking_url: string | null;
    is_booking_enabled: boolean;
    created_at: string | null;
    updated_at: string | null;
};

/**
 * TenantOnboardingStage
 */
export enum TenantOnboardingStage {
    REGISTER = 'Register',
    BUSINESS_DETAILS = 'Business Details',
    FINISHED = 'Finished'
}

/**
 * TenantType
 */
export enum TenantType {
    GROOMING_SALON = 'Grooming Salon',
    MOBILE_GROOMER = 'Mobile Groomer',
    OTHER = 'Other'
}

/**
 * UpdateRequest
 */
export type UpdateRequest = {
    notes?: string | null;
    status?: AppointmentStatus;
    approved_at?: string;
};

/**
 * UploadUrlRequest
 */
export type UploadUrlRequest = {
    file_extension: string;
    content_type: string;
};

/**
 * User
 */
export type User = {
    id: number;
    first_name: string;
    last_name: string;
    email: string;
    phone: string | null;
    image: string;
    role: Role;
    created_at: string | null;
    updated_at: string | null;
    deleted_at: string | null;
    tutorial_completed_at: string | null;
    approved_at: string;
};

/**
 * UserAppointment
 */
export type UserAppointment = {
    id: string;
    first_name: string;
    last_name: string;
    schedule: Array<Schedule>;
    appointments: Array<Appointment>;
};

/**
 * VerifyRequest
 */
export type VerifyRequest = {
    email: string;
    code: string;
};

export type AppointmentPublicConfirmData = {
    body: PublicConfirmRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/appointments/{id}/confirm';
};

export type AppointmentPublicConfirmErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentPublicConfirmError = AppointmentPublicConfirmErrors[keyof AppointmentPublicConfirmErrors];

export type AppointmentPublicConfirmResponses = {
    /**
     * No content
     */
    204: void;
};

export type AppointmentPublicConfirmResponse = AppointmentPublicConfirmResponses[keyof AppointmentPublicConfirmResponses];

export type AppointmentPublicCancelData = {
    body: PublicCancelRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/appointments/{id}/cancel';
};

export type AppointmentPublicCancelErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentPublicCancelError = AppointmentPublicCancelErrors[keyof AppointmentPublicCancelErrors];

export type AppointmentPublicCancelResponses = {
    /**
     * No content
     */
    204: void;
};

export type AppointmentPublicCancelResponse = AppointmentPublicCancelResponses[keyof AppointmentPublicCancelResponses];

export type AppointmentIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        /**
         * Modern filtering using FilterParser
         */
        filters?: string | null;
        /**
         * Legacy filters for backward compatibility
         */
        start_at?: string;
        finish_at?: string;
        approved?: 'pending' | 'approved';
        status?: AppointmentStatus;
        client?: number;
        pet?: number;
        query?: string | null;
        sort?: Array<string> | null;
    };
    url: '/appointments';
};

export type AppointmentIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentIndexError = AppointmentIndexErrors[keyof AppointmentIndexErrors];

export type AppointmentIndexResponses = {
    /**
     * Paginated set of `Appointment`
     */
    200: {
        data: Array<Appointment>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type AppointmentIndexResponse = AppointmentIndexResponses[keyof AppointmentIndexResponses];

export type AppointmentCalendarData = {
    body?: never;
    path?: never;
    query?: {
        start_at?: string;
        finish_at?: string;
        groomers?: Array<string>;
    };
    url: '/appointments/calendar';
};

export type AppointmentCalendarErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentCalendarError = AppointmentCalendarErrors[keyof AppointmentCalendarErrors];

export type AppointmentCalendarResponses = {
    /**
     * Array of `UserAppointment`
     */
    200: {
        data: Array<UserAppointment>;
        calendar_blocks: Array<CalendarBlock>;
    };
};

export type AppointmentCalendarResponse = AppointmentCalendarResponses[keyof AppointmentCalendarResponses];

export type AppointmentMetadataData = {
    body?: never;
    path?: never;
    query: {
        pet_id?: number | null;
        pet_breed?: DogBreed;
        size_category_id?: number | null;
        coat_type_id?: number | null;
        services: Array<number>;
    };
    url: '/appointments/metadata';
};

export type AppointmentMetadataErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentMetadataError = AppointmentMetadataErrors[keyof AppointmentMetadataErrors];

export type AppointmentMetadataResponses = {
    /**
     * `AppointmentMetadata`
     */
    200: {
        data: AppointmentMetadata;
    };
};

export type AppointmentMetadataResponse = AppointmentMetadataResponses[keyof AppointmentMetadataResponses];

export type AppointmentSlotsData = {
    body?: never;
    path?: never;
    query: {
        page?: number;
        per_page?: number;
        date: string;
        duration: number;
        groomers?: Array<number>;
    };
    url: '/appointments/slots';
};

export type AppointmentSlotsErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentSlotsError = AppointmentSlotsErrors[keyof AppointmentSlotsErrors];

export type AppointmentSlotsResponses = {
    /**
     * Paginated set of `AppointmentSlot`
     */
    200: {
        data: Array<AppointmentSlot>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type AppointmentSlotsResponse = AppointmentSlotsResponses[keyof AppointmentSlotsResponses];

export type AppointmentNextAvailableDateData = {
    body?: never;
    path?: never;
    query: {
        duration: number;
        max_days_to_check?: number;
        /**
         * Max 24 hours
         */
        groomers?: Array<number>;
    };
    url: '/appointments/next-available-date';
};

export type AppointmentNextAvailableDateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    404: {
        message: string;
        date: null;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentNextAvailableDateError = AppointmentNextAvailableDateErrors[keyof AppointmentNextAvailableDateErrors];

export type AppointmentNextAvailableDateResponses = {
    200: {
        date: string;
    };
};

export type AppointmentNextAvailableDateResponse = AppointmentNextAvailableDateResponses[keyof AppointmentNextAvailableDateResponses];

export type AppointmentCreateData = {
    body: CreateRequest;
    path?: never;
    query?: never;
    url: '/appointments/create';
};

export type AppointmentCreateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentCreateError = AppointmentCreateErrors[keyof AppointmentCreateErrors];

export type AppointmentCreateResponses = {
    200: string;
};

export type AppointmentCreateResponse = AppointmentCreateResponses[keyof AppointmentCreateResponses];

export type AppointmentDestroyData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/appointments/{id}';
};

export type AppointmentDestroyErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentDestroyError = AppointmentDestroyErrors[keyof AppointmentDestroyErrors];

export type AppointmentDestroyResponses = {
    /**
     * No content
     */
    204: void;
};

export type AppointmentDestroyResponse = AppointmentDestroyResponses[keyof AppointmentDestroyResponses];

export type AppointmentShowData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        include_unapproved?: boolean;
    };
    url: '/appointments/{id}';
};

export type AppointmentShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentShowError = AppointmentShowErrors[keyof AppointmentShowErrors];

export type AppointmentShowResponses = {
    /**
     * `Appointment`
     */
    200: {
        data: Appointment;
    };
};

export type AppointmentShowResponse = AppointmentShowResponses[keyof AppointmentShowResponses];

export type AppointmentUpdateData = {
    body?: UpdateRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/appointments/{id}';
};

export type AppointmentUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentUpdateError = AppointmentUpdateErrors[keyof AppointmentUpdateErrors];

export type AppointmentUpdateResponses = {
    200: string;
};

export type AppointmentUpdateResponse = AppointmentUpdateResponses[keyof AppointmentUpdateResponses];

export type AppointmentCancelData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/appointments/{id}';
};

export type AppointmentCancelErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentCancelError = AppointmentCancelErrors[keyof AppointmentCancelErrors];

export type AppointmentCancelResponses = {
    /**
     * No content
     */
    204: void;
};

export type AppointmentCancelResponse = AppointmentCancelResponses[keyof AppointmentCancelResponses];

export type AppointmentRescheduleData = {
    body: RescheduleRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/appointments/{id}/reschedule';
};

export type AppointmentRescheduleErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AppointmentRescheduleError = AppointmentRescheduleErrors[keyof AppointmentRescheduleErrors];

export type AppointmentRescheduleResponses = {
    200: string;
};

export type AppointmentRescheduleResponse = AppointmentRescheduleResponses[keyof AppointmentRescheduleResponses];

export type AuthLoginData = {
    body: LoginRequest;
    path?: never;
    query?: never;
    url: '/auth/login';
};

export type AuthLoginErrors = {
    401: {
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AuthLoginError = AuthLoginErrors[keyof AuthLoginErrors];

export type AuthLoginResponses = {
    /**
     * `User`
     */
    200: {
        data: User;
    };
};

export type AuthLoginResponse = AuthLoginResponses[keyof AuthLoginResponses];

export type AuthForgotPasswordData = {
    body: ForgotPasswordRequest;
    path?: never;
    query?: never;
    url: '/auth/forgot-password';
};

export type AuthForgotPasswordErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AuthForgotPasswordError = AuthForgotPasswordErrors[keyof AuthForgotPasswordErrors];

export type AuthForgotPasswordResponses = {
    /**
     * No content
     */
    204: void;
};

export type AuthForgotPasswordResponse = AuthForgotPasswordResponses[keyof AuthForgotPasswordResponses];

export type AuthResetPasswordData = {
    body: ResetPasswordRequest;
    path?: never;
    query?: never;
    url: '/auth/reset-password';
};

export type AuthResetPasswordErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type AuthResetPasswordError = AuthResetPasswordErrors[keyof AuthResetPasswordErrors];

export type AuthResetPasswordResponses = {
    200: unknown;
};

export type AuthUserData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/auth/user';
};

export type AuthUserErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type AuthUserError = AuthUserErrors[keyof AuthUserErrors];

export type AuthUserResponses = {
    /**
     * `User`
     */
    200: {
        data: User;
    };
};

export type AuthUserResponse = AuthUserResponses[keyof AuthUserResponses];

export type AuthLogOutData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/auth/logout';
};

export type AuthLogOutErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type AuthLogOutError = AuthLogOutErrors[keyof AuthLogOutErrors];

export type AuthLogOutResponses = {
    /**
     * No content
     */
    204: void;
};

export type AuthLogOutResponse = AuthLogOutResponses[keyof AuthLogOutResponses];

export type ClientIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        query?: string | null;
        sort?: Array<string> | null;
    };
    url: '/clients';
};

export type ClientIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ClientIndexError = ClientIndexErrors[keyof ClientIndexErrors];

export type ClientIndexResponses = {
    /**
     * Paginated set of `Client`
     */
    200: {
        data: Array<Client>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type ClientIndexResponse = ClientIndexResponses[keyof ClientIndexResponses];

export type ClientStoreData = {
    body: StoreRequest;
    path?: never;
    query?: never;
    url: '/clients';
};

export type ClientStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ClientStoreError = ClientStoreErrors[keyof ClientStoreErrors];

export type ClientStoreResponses = {
    200: string;
};

export type ClientStoreResponse = ClientStoreResponses[keyof ClientStoreResponses];

export type ClientDeleteData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/clients/{id}';
};

export type ClientDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ClientDeleteError = ClientDeleteErrors[keyof ClientDeleteErrors];

export type ClientDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type ClientDeleteResponse = ClientDeleteResponses[keyof ClientDeleteResponses];

export type ClientShowData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        include_deleted?: boolean;
        include_unapproved?: boolean;
    };
    url: '/clients/{id}';
};

export type ClientShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ClientShowError = ClientShowErrors[keyof ClientShowErrors];

export type ClientShowResponses = {
    /**
     * `Client`
     */
    200: {
        data: Client;
    };
};

export type ClientShowResponse = ClientShowResponses[keyof ClientShowResponses];

export type ClientUpdateData = {
    body?: never;
    path: {
        /**
         * The client ID
         */
        client: number;
    };
    query?: never;
    url: '/clients/{client}';
};

export type ClientUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Not found
     */
    404: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ClientUpdateError = ClientUpdateErrors[keyof ClientUpdateErrors];

export type ClientUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type ClientUpdateResponse = ClientUpdateResponses[keyof ClientUpdateResponses];

export type CoatTypeIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        query?: string | null;
    };
    url: '/coat-types';
};

export type CoatTypeIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type CoatTypeIndexError = CoatTypeIndexErrors[keyof CoatTypeIndexErrors];

export type CoatTypeIndexResponses = {
    /**
     * Paginated set of `CoatType`
     */
    200: {
        data: Array<CoatType>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type CoatTypeIndexResponse = CoatTypeIndexResponses[keyof CoatTypeIndexResponses];

export type CoatTypeStoreData = {
    body: AppHttpRequestsCoatTypeStoreRequest;
    path?: never;
    query?: never;
    url: '/coat-types';
};

export type CoatTypeStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type CoatTypeStoreError = CoatTypeStoreErrors[keyof CoatTypeStoreErrors];

export type CoatTypeStoreResponses = {
    201: unknown;
};

export type CoatTypeDeleteData = {
    body?: never;
    path: {
        coatType: number;
    };
    query?: never;
    url: '/coat-types/{coatType}';
};

export type CoatTypeDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type CoatTypeDeleteError = CoatTypeDeleteErrors[keyof CoatTypeDeleteErrors];

export type CoatTypeDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type CoatTypeDeleteResponse = CoatTypeDeleteResponses[keyof CoatTypeDeleteResponses];

export type CoatTypeShowData = {
    body?: never;
    path: {
        coatType: number;
    };
    query?: never;
    url: '/coat-types/{coatType}';
};

export type CoatTypeShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type CoatTypeShowError = CoatTypeShowErrors[keyof CoatTypeShowErrors];

export type CoatTypeShowResponses = {
    /**
     * `CoatType`
     */
    200: {
        data: CoatType;
    };
};

export type CoatTypeShowResponse = CoatTypeShowResponses[keyof CoatTypeShowResponses];

export type CoatTypeUpdateData = {
    body?: AppHttpRequestsCoatTypeUpdateRequest;
    path: {
        coatType: number;
    };
    query?: never;
    url: '/coat-types/{coatType}';
};

export type CoatTypeUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type CoatTypeUpdateError = CoatTypeUpdateErrors[keyof CoatTypeUpdateErrors];

export type CoatTypeUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type CoatTypeUpdateResponse = CoatTypeUpdateResponses[keyof CoatTypeUpdateResponses];

export type ContactSubmissionStoreData = {
    body: AppHttpRequestsContactSubmissionStoreRequest;
    path?: never;
    query?: never;
    url: '/contact';
};

export type ContactSubmissionStoreErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ContactSubmissionStoreError = ContactSubmissionStoreErrors[keyof ContactSubmissionStoreErrors];

export type ContactSubmissionStoreResponses = {
    201: unknown;
};

export type InvitationSendVerificationCodeData = {
    body: SendVerificationCodeRequest;
    path?: never;
    query?: never;
    url: '/invitations/verification-code';
};

export type InvitationSendVerificationCodeErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type InvitationSendVerificationCodeError = InvitationSendVerificationCodeErrors[keyof InvitationSendVerificationCodeErrors];

export type InvitationSendVerificationCodeResponses = {
    200: unknown;
};

export type InvitationVerifyData = {
    body: VerifyRequest;
    path?: never;
    query?: never;
    url: '/invitations/verify';
};

export type InvitationVerifyErrors = {
    401: {
        message: string;
        errors: {
            code: [
                string
            ];
        };
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type InvitationVerifyError = InvitationVerifyErrors[keyof InvitationVerifyErrors];

export type InvitationVerifyResponses = {
    200: unknown;
};

export type InvitationShowData = {
    body?: never;
    path: {
        token: string;
    };
    query?: never;
    url: '/invitations/{token}';
};

export type InvitationShowResponses = {
    /**
     * `Invitation`
     */
    200: Invitation;
};

export type InvitationShowResponse = InvitationShowResponses[keyof InvitationShowResponses];

export type InvitationRegisterData = {
    body: RegisterRequest;
    path: {
        token: string;
    };
    query?: never;
    url: '/invitations/{token}';
};

export type InvitationRegisterErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type InvitationRegisterError = InvitationRegisterErrors[keyof InvitationRegisterErrors];

export type InvitationIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        sort?: Array<string> | null;
    };
    url: '/invitations';
};

export type InvitationIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type InvitationIndexError = InvitationIndexErrors[keyof InvitationIndexErrors];

export type InvitationIndexResponses = {
    /**
     * Paginated set of `Invitation`
     */
    200: {
        data: Array<Invitation>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type InvitationIndexResponse = InvitationIndexResponses[keyof InvitationIndexResponses];

export type InvitationStoreData = {
    body: AppHttpRequestsInvitationStoreRequest;
    path?: never;
    query?: never;
    url: '/invitations';
};

export type InvitationStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type InvitationStoreError = InvitationStoreErrors[keyof InvitationStoreErrors];

export type InvitationStoreResponses = {
    201: unknown;
};

export type InvitationDeleteData = {
    body?: never;
    path: {
        id: string;
    };
    query?: never;
    url: '/invitations/{id}';
};

export type InvitationDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type InvitationDeleteError = InvitationDeleteErrors[keyof InvitationDeleteErrors];

export type InvitationDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type InvitationDeleteResponse = InvitationDeleteResponses[keyof InvitationDeleteResponses];

export type LocationIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
    };
    url: '/locations';
};

export type LocationIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type LocationIndexError = LocationIndexErrors[keyof LocationIndexErrors];

export type LocationIndexResponses = {
    /**
     * Array of `Location`
     */
    200: {
        data: Array<Location>;
    };
};

export type LocationIndexResponse = LocationIndexResponses[keyof LocationIndexResponses];

export type LocationStoreData = {
    body: AppHttpRequestsLocationStoreRequest;
    path?: never;
    query?: never;
    url: '/locations';
};

export type LocationStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type LocationStoreError = LocationStoreErrors[keyof LocationStoreErrors];

export type LocationStoreResponses = {
    200: unknown;
};

export type LocationDeleteData = {
    body?: never;
    path: {
        location: number;
    };
    query?: never;
    url: '/locations/{location}';
};

export type LocationDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type LocationDeleteError = LocationDeleteErrors[keyof LocationDeleteErrors];

export type LocationDeleteResponses = {
    200: unknown;
};

export type LocationShowData = {
    body?: never;
    path: {
        location: number;
    };
    query?: never;
    url: '/locations/{location}';
};

export type LocationShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type LocationShowError = LocationShowErrors[keyof LocationShowErrors];

export type LocationShowResponses = {
    /**
     * `Location`
     */
    200: {
        data: Location;
    };
};

export type LocationShowResponse = LocationShowResponses[keyof LocationShowResponses];

export type LocationUpdateData = {
    body?: AppHttpRequestsLocationUpdateRequest;
    path: {
        location: number;
    };
    query?: never;
    url: '/locations/{location}';
};

export type LocationUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type LocationUpdateError = LocationUpdateErrors[keyof LocationUpdateErrors];

export type LocationUpdateResponses = {
    200: unknown;
};

export type MediaGenerateUploadUrlData = {
    body: UploadUrlRequest;
    path?: never;
    query?: never;
    url: '/media/upload-url';
};

export type MediaGenerateUploadUrlErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type MediaGenerateUploadUrlError = MediaGenerateUploadUrlErrors[keyof MediaGenerateUploadUrlErrors];

export type MediaGenerateUploadUrlResponses = {
    /**
     * `MediaObject`
     */
    200: {
        data: MediaObject;
    };
};

export type MediaGenerateUploadUrlResponse = MediaGenerateUploadUrlResponses[keyof MediaGenerateUploadUrlResponses];

export type NewsletterStoreData = {
    body: AppHttpRequestsNewsletterStoreRequest;
    path?: never;
    query?: never;
    url: '/newsletter';
};

export type NewsletterStoreErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type NewsletterStoreError = NewsletterStoreErrors[keyof NewsletterStoreErrors];

export type NewsletterStoreResponses = {
    201: unknown;
};

export type PetIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        query?: string | null;
        parent_id?: number;
        sort?: Array<string> | null;
    };
    url: '/pets';
};

export type PetIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type PetIndexError = PetIndexErrors[keyof PetIndexErrors];

export type PetIndexResponses = {
    /**
     * Paginated set of `Pet`
     */
    200: {
        data: Array<Pet>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type PetIndexResponse = PetIndexResponses[keyof PetIndexResponses];

export type PetStoreData = {
    body: AppHttpRequestsPetStoreRequest;
    path?: never;
    query?: never;
    url: '/pets';
};

export type PetStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type PetStoreError = PetStoreErrors[keyof PetStoreErrors];

export type PetStoreResponses = {
    201: unknown;
};

export type PetDeleteData = {
    body?: never;
    path: {
        /**
         * The pet ID
         */
        pet: number;
    };
    query?: never;
    url: '/pets/{pet}';
};

export type PetDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Not found
     */
    404: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type PetDeleteError = PetDeleteErrors[keyof PetDeleteErrors];

export type PetDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type PetDeleteResponse = PetDeleteResponses[keyof PetDeleteResponses];

export type PetShowData = {
    body?: never;
    path: {
        pet: number;
    };
    query?: {
        include_deleted?: boolean;
        include_unapproved?: boolean;
    };
    url: '/pets/{pet}';
};

export type PetShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type PetShowError = PetShowErrors[keyof PetShowErrors];

export type PetShowResponses = {
    /**
     * `Pet`
     */
    200: {
        data: Pet;
    };
};

export type PetShowResponse = PetShowResponses[keyof PetShowResponses];

export type PetUpdateData = {
    body?: AppHttpRequestsPetUpdateRequest;
    path: {
        /**
         * The pet ID
         */
        pet: number;
    };
    query?: never;
    url: '/pets/{pet}';
};

export type PetUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Not found
     */
    404: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type PetUpdateError = PetUpdateErrors[keyof PetUpdateErrors];

export type PetUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type PetUpdateResponse = PetUpdateResponses[keyof PetUpdateResponses];

export type ScheduleShowData = {
    body?: never;
    path: {
        userId: number;
    };
    query?: {
        include_deleted?: boolean;
    };
    url: '/schedules/{userId}';
};

export type ScheduleShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ScheduleShowError = ScheduleShowErrors[keyof ScheduleShowErrors];

export type ScheduleShowResponses = {
    /**
     * Array of `Schedule`
     */
    200: {
        data: Array<Schedule>;
    };
};

export type ScheduleShowResponse = ScheduleShowResponses[keyof ScheduleShowResponses];

export type ScheduleUpdateData = {
    body: AppHttpRequestsScheduleUpdateRequest;
    path: {
        userId: number;
    };
    query?: never;
    url: '/schedules/{userId}';
};

export type ScheduleUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ScheduleUpdateError = ScheduleUpdateErrors[keyof ScheduleUpdateErrors];

export type ScheduleUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type ScheduleUpdateResponse = ScheduleUpdateResponses[keyof ScheduleUpdateResponses];

export type ServiceIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        query?: string | null;
        pet_id?: number | null;
        sort?: Array<string> | null;
    };
    url: '/services';
};

export type ServiceIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceIndexError = ServiceIndexErrors[keyof ServiceIndexErrors];

export type ServiceIndexResponses = {
    /**
     * Paginated set of `Service`
     */
    200: {
        data: Array<Service>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type ServiceIndexResponse = ServiceIndexResponses[keyof ServiceIndexResponses];

export type ServiceStoreData = {
    body: AppHttpRequestsServiceStoreRequest;
    path?: never;
    query?: never;
    url: '/services';
};

export type ServiceStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceStoreError = ServiceStoreErrors[keyof ServiceStoreErrors];

export type ServiceStoreResponses = {
    201: unknown;
};

export type ServiceDeleteData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/services/{id}';
};

export type ServiceDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceDeleteError = ServiceDeleteErrors[keyof ServiceDeleteErrors];

export type ServiceDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type ServiceDeleteResponse = ServiceDeleteResponses[keyof ServiceDeleteResponses];

export type ServiceShowData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        values_id?: number;
        include_deleted?: boolean;
    };
    url: '/services/{id}';
};

export type ServiceShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceShowError = ServiceShowErrors[keyof ServiceShowErrors];

export type ServiceShowResponses = {
    /**
     * `Service`
     */
    200: {
        data: Service;
    };
};

export type ServiceShowResponse = ServiceShowResponses[keyof ServiceShowResponses];

export type ServiceUpdateData = {
    body?: AppHttpRequestsServiceUpdateRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/services/{id}';
};

export type ServiceUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceUpdateError = ServiceUpdateErrors[keyof ServiceUpdateErrors];

export type ServiceUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type ServiceUpdateResponse = ServiceUpdateResponses[keyof ServiceUpdateResponses];

export type ServiceVariantIndexData = {
    body?: never;
    path: {
        serviceId: number;
    };
    query?: never;
    url: '/service-variants/{serviceId}';
};

export type ServiceVariantIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceVariantIndexError = ServiceVariantIndexErrors[keyof ServiceVariantIndexErrors];

export type ServiceVariantIndexResponses = {
    /**
     * Array of `ServiceValueVariant`
     */
    200: {
        data: Array<ServiceValueVariant>;
    };
};

export type ServiceVariantIndexResponse = ServiceVariantIndexResponses[keyof ServiceVariantIndexResponses];

export type ServiceVariantSyncData = {
    body: SyncRequest;
    path: {
        serviceId: number;
    };
    query?: never;
    url: '/service-variants/{serviceId}';
};

export type ServiceVariantSyncErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type ServiceVariantSyncError = ServiceVariantSyncErrors[keyof ServiceVariantSyncErrors];

export type ServiceVariantSyncResponses = {
    200: unknown;
};

export type SizeCategoryIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        query?: string | null;
    };
    url: '/size-categories';
};

export type SizeCategoryIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type SizeCategoryIndexError = SizeCategoryIndexErrors[keyof SizeCategoryIndexErrors];

export type SizeCategoryIndexResponses = {
    /**
     * Paginated set of `SizeCategory`
     */
    200: {
        data: Array<SizeCategory>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type SizeCategoryIndexResponse = SizeCategoryIndexResponses[keyof SizeCategoryIndexResponses];

export type SizeCategoryStoreData = {
    body: AppHttpRequestsSizeCategoryStoreRequest;
    path?: never;
    query?: never;
    url: '/size-categories';
};

export type SizeCategoryStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type SizeCategoryStoreError = SizeCategoryStoreErrors[keyof SizeCategoryStoreErrors];

export type SizeCategoryStoreResponses = {
    201: unknown;
};

export type SizeCategoryDeleteData = {
    body?: never;
    path: {
        sizeCategory: number;
    };
    query?: never;
    url: '/size-categories/{sizeCategory}';
};

export type SizeCategoryDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type SizeCategoryDeleteError = SizeCategoryDeleteErrors[keyof SizeCategoryDeleteErrors];

export type SizeCategoryDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type SizeCategoryDeleteResponse = SizeCategoryDeleteResponses[keyof SizeCategoryDeleteResponses];

export type SizeCategoryShowData = {
    body?: never;
    path: {
        sizeCategory: number;
    };
    query?: never;
    url: '/size-categories/{sizeCategory}';
};

export type SizeCategoryShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type SizeCategoryShowError = SizeCategoryShowErrors[keyof SizeCategoryShowErrors];

export type SizeCategoryShowResponses = {
    /**
     * `SizeCategory`
     */
    200: {
        data: SizeCategory;
    };
};

export type SizeCategoryShowResponse = SizeCategoryShowResponses[keyof SizeCategoryShowResponses];

export type SizeCategoryUpdateData = {
    body: AppHttpRequestsSizeCategoryUpdateRequest;
    path: {
        sizeCategory: number;
    };
    query?: never;
    url: '/size-categories/{sizeCategory}';
};

export type SizeCategoryUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type SizeCategoryUpdateError = SizeCategoryUpdateErrors[keyof SizeCategoryUpdateErrors];

export type SizeCategoryUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type SizeCategoryUpdateResponse = SizeCategoryUpdateResponses[keyof SizeCategoryUpdateResponses];

export type StripeWebhookHandleData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/stripe/webhook';
};

export type StripeWebhookHandleResponses = {
    200: unknown;
};

export type SupportTicketStoreData = {
    body: AppHttpRequestsSupportTicketStoreRequest;
    path?: never;
    query?: never;
    url: '/support';
};

export type SupportTicketStoreErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type SupportTicketStoreError = SupportTicketStoreErrors[keyof SupportTicketStoreErrors];

export type SupportTicketStoreResponses = {
    201: unknown;
};

export type TenantIndexData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/tenants';
};

export type TenantIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type TenantIndexError = TenantIndexErrors[keyof TenantIndexErrors];

export type TenantIndexResponses = {
    200: string;
};

export type TenantIndexResponse = TenantIndexResponses[keyof TenantIndexResponses];

export type TenantShowByBookingUrlData = {
    body?: never;
    path: {
        bookingUrl: string;
    };
    query?: never;
    url: '/tenants/booking/{bookingUrl}';
};

export type TenantShowByBookingUrlResponses = {
    /**
     * `PublicTenant`
     */
    200: {
        data: PublicTenant;
    };
};

export type TenantShowByBookingUrlResponse = TenantShowByBookingUrlResponses[keyof TenantShowByBookingUrlResponses];

export type TenantActiveData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/tenants/active';
};

export type TenantActiveErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    404: {
        message: string;
    };
};

export type TenantActiveError = TenantActiveErrors[keyof TenantActiveErrors];

export type TenantActiveResponses = {
    /**
     * `Tenant`
     */
    200: {
        data: Tenant;
    };
};

export type TenantActiveResponse = TenantActiveResponses[keyof TenantActiveResponses];

export type TenantUpdateData = {
    body?: AppHttpRequestsTenantUpdateRequest;
    path: {
        id: string;
    };
    query?: never;
    url: '/tenants/{id}';
};

export type TenantUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type TenantUpdateError = TenantUpdateErrors[keyof TenantUpdateErrors];

export type TenantUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type TenantUpdateResponse = TenantUpdateResponses[keyof TenantUpdateResponses];

export type TenantOnboardingRegisterData = {
    body: AppHttpRequestsTenantOnboardingRegisterRequest;
    path?: never;
    query?: never;
    url: '/auth/register';
};

export type TenantOnboardingRegisterErrors = {
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type TenantOnboardingRegisterError = TenantOnboardingRegisterErrors[keyof TenantOnboardingRegisterErrors];

export type TenantOnboardingRegisterResponses = {
    200: unknown;
};

export type TenantOnboardingUpdateData = {
    body: AppHttpRequestsTenantOnboardingUpdateRequest;
    path?: never;
    query?: never;
    url: '/onboarding';
};

export type TenantOnboardingUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type TenantOnboardingUpdateError = TenantOnboardingUpdateErrors[keyof TenantOnboardingUpdateErrors];

export type TenantOnboardingUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type TenantOnboardingUpdateResponse = TenantOnboardingUpdateResponses[keyof TenantOnboardingUpdateResponses];

export type TutorialCompleteData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/tutorial/complete';
};

export type TutorialCompleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
};

export type TutorialCompleteError = TutorialCompleteErrors[keyof TutorialCompleteErrors];

export type TutorialCompleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type TutorialCompleteResponse = TutorialCompleteResponses[keyof TutorialCompleteResponses];

export type UserIndexData = {
    body?: never;
    path?: never;
    query?: {
        page?: number;
        per_page?: number;
        query?: string | null;
        tenant_id?: string | null;
        include_deleted?: boolean;
        sort?: Array<string> | null;
        roles?: Array<Role>;
    };
    url: '/users';
};

export type UserIndexErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type UserIndexError = UserIndexErrors[keyof UserIndexErrors];

export type UserIndexResponses = {
    /**
     * Paginated set of `User`
     */
    200: {
        data: Array<User>;
        meta: {
            current_page: number;
            from: number | null;
            last_page: number;
            /**
             * Generated paginator links.
             */
            links: Array<{
                url: string | null;
                label: string;
                active: boolean;
            }>;
            /**
             * Base path for paginator generated URLs.
             */
            path: string | null;
            /**
             * Number of items shown per page.
             */
            per_page: number;
            /**
             * Number of the last item in the slice.
             */
            to: number | null;
            /**
             * Total number of items being paginated.
             */
            total: number;
        };
        links: {
            first: string | null;
            last: string | null;
            prev: string | null;
            next: string | null;
        };
    };
};

export type UserIndexResponse = UserIndexResponses[keyof UserIndexResponses];

export type UserDeleteData = {
    body?: never;
    path: {
        id: number;
    };
    query?: never;
    url: '/users/{id}';
};

export type UserDeleteErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type UserDeleteError = UserDeleteErrors[keyof UserDeleteErrors];

export type UserDeleteResponses = {
    /**
     * No content
     */
    204: void;
};

export type UserDeleteResponse = UserDeleteResponses[keyof UserDeleteResponses];

export type UserShowData = {
    body?: never;
    path: {
        id: number;
    };
    query?: {
        include_deleted?: boolean;
    };
    url: '/users/{id}';
};

export type UserShowErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type UserShowError = UserShowErrors[keyof UserShowErrors];

export type UserShowResponses = {
    /**
     * `User`
     */
    200: {
        data: User;
    };
};

export type UserShowResponse = UserShowResponses[keyof UserShowResponses];

export type UserUpdateData = {
    body?: AppHttpRequestsUserUpdateRequest;
    path: {
        id: number;
    };
    query?: never;
    url: '/users/{id}';
};

export type UserUpdateErrors = {
    /**
     * Unauthenticated
     */
    401: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Authorization error
     */
    403: {
        /**
         * Error overview.
         */
        message: string;
    };
    /**
     * Validation error
     */
    422: {
        /**
         * Errors overview.
         */
        message: string;
        /**
         * A detailed description of each field that failed validation.
         */
        errors: {
            [key: string]: Array<string>;
        };
    };
};

export type UserUpdateError = UserUpdateErrors[keyof UserUpdateErrors];

export type UserUpdateResponses = {
    /**
     * No content
     */
    204: void;
};

export type UserUpdateResponse = UserUpdateResponses[keyof UserUpdateResponses];

export type ClientOptions = {
    baseUrl: 'https://api.tailly.net/api' | (string & {});
};